// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j4-0";
export var fileCarousel = "_j4-2";
export var removeFileButton = "_j4-1";